/**
 * Licensed Materials - Property of ROOTCLOUD
 * THIS MODULE IS "RESTRICTED MATERIALS OF ROOTCLOUD"
 * (c) Copyright ROOTCLOUD Inc. 2021 All Rights Reserved
 *
 * The source code for this program is not published or
 * otherwise divested of its trade secrets
 */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

export const viewNames = [
  {
    path: "/dict/dict-list",
    name: "DictList"
  },
  {
    path: "/dict/dict-list-init",
    name: "DictListInit"
  },
  {
    path: "/business/business-list",
    name: "Business"
  },
  {
    path: "/code/code-list",
    name: "CodeList"
  },
  {
    path: "/dashboard/index",
    name: "PageDeveloping"
  },
  {
    path: "/home/index",
    name: "Commonhome"
  },
  {
    path: "/import/import-configuration",
    name: "EquipAccountList"
  },
  {
    path: "/log/job/job-list",
    name: "JobList"
  },
  {
    path: "/log/excel",
    name: "ExcelImportRecord"
  },
  {
    path: "/log/login/login-list",
    name: "LogLoginList"
  },
  {
    path: "/log/operate/operate-list",
    name: "OperateList"
  },
  {
    path: "/menu/menu-list",
    name: "MenuList"
  },
  {
    path: "/menu/menu-list-sys",
    name: "MenuListSys"
  },
  {
    path: "/role/role-list",
    name: "RoleList"
  },
  {
    path: "/role/role-list-init",
    name: "RoleListInit"
  },
  {
    path: "/user/user-list",
    name: "UserList"
  },
  {
    path: "/data-permissions/resources-permission-set",
    name: "ResourcePermissionSet"
  },
  {
    path: "/permission/permission-config",
    name: "PermissionConfig"
  },
  {
    path: "/permission/permission-config-data",
    name: "PermissionConfigData"
  },
  {
    path: "/org-new/org-new-list",
    name: "OrgNewList"
  },
  {
    path: "/user-new/user-new-list",
    name: "UserNewList"
  },
  {
    path: "/external-container",
    name: "ExternalContainer"
  },
  {
    path: "/depart-manage/depart-manage-list",
    name: "DepartManageList"
  },
  {
    path: "/report-config/report-config-list",
    name: "ReportConfigList"
  },
  {
    path: "/report-config/report-config-add",
    name: "ReportConfigAdd"
  },
  {
    path: "/report-config/report-config-edit",
    name: "ReportConfigEdit"
  },
  {
    path: "/report-config/report-config-details",
    name: "ReportConfigDetails"
  }
];
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/standard/login/index"),
    hidden: true
  },

  /*
   * 用于刷新页签,重置字体大小时用
   * 定义一个空白路由页面，路由跳转到该空白页后立马跳回当前页，实现路由刷新
   */
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/standard/redirect/index")
      }
    ]
  },
  // 忘记密码
  {
    path: "/getBackPassword",
    component: () => import("@/views/standard/getBackPassword/index"),
    hidden: true
  },
  {
    path: "/import",
    component: Layout,
    name: "ImportConfiguration",
    redirect: "/import/import-configuration",
    hidden: true,
    meta: { title: "Excel导入配置", icon: "el-icon-s-custom" },
    children: [
      {
        path: "/import/add-and-edit",
        name: "AddEdit",
        hidden: true,
        component: () => import("@/views/standard/import/components/add-and-edit"),
        meta: {
          breadcrumb: false,
          hiddenTag: true, //  在tags模式下是否显示
          tagReplace: "/import/import-configuration", //  替代显示tag的路由
          nocache: true,
          title: "导入添加",
          icon: "el-icon-user-solid"
        }
      },
      {
        path: "/import/property-setting",
        name: "PropertySetting",
        hidden: true,
        component: () => import("@/views/standard/import/components/property-setting"),
        meta: {
          breadcrumb: false,
          nocache: true,
          title: "导入添加",
          icon: "el-icon-user-solid"
        }
      }
    ]
  },
  {
    path: "/report-config",
    component: Layout,
    redirect: "/report-config/report-config-list",
    meta: { title: "报表配置" },
    hidden: true,
    children: [
      {
        path: "report-config-list",
        name: "ReportConfigList",
        component: () => import("@/views/standard/report-config/report-config-list"),
        hidden: true,
        meta: { title: "报表列表" }
      },
      {
        path: "report-config-add",
        name: "ReportConfigAdd",
        component: () => import("@/views/standard/report-config/report-config-add"),
        hidden: true,
        meta: {
          title: "新增报表",
          breadcrumb: false,
          hiddenTag: true, //  在tags模式下是否显示
          tagReplace: "/report-config/report-config-list" //  替代显示tag的路由
        }
      },
      {
        path: "report-config-edit",
        name: "ReportConfigEdit",
        component: () => import("@/views/standard/report-config/report-config-edit"),
        hidden: true,
        meta: {
          title: "编辑报表",
          breadcrumb: false,
          hiddenTag: true, //  在tags模式下是否显示
          tagReplace: "/report-config/report-config-list" //  替代显示tag的路由
        }
      },
      {
        path: "report-config-details",
        name: "ReportConfigDetails",
        component: () => import("@/views/standard/report-config/report-config-details"),
        hidden: true,
        meta: {
          title: "报表详情",
          breadcrumb: false,
          hiddenTag: true, //  在tags模式下是否显示
          tagReplace: "/report-config/report-config-list" //  替代显示tag的路由
        }
      }
    ]
  },
  {
    path: "/data-permissions",
    component: Layout,
    redirect: "/data-permissions/resources-manage",
    meta: { title: "数据权限" },
    hidden: true,
    children: [
      {
        path: "/data-permissions/resources-manage",
        name: "ResourceMange",
        component: () => import("@/views/standard/dataPermission/resourceManage/newResourceManage"),
        hidden: true,
        meta: { title: "资源管理" }
      },
      {
        path: "/data-permissions/resources-permission-set",
        name: "ResourcePermissionSet",
        component: () => import("@/views/standard/dataPermission/resourcePermissionSet/resourcePermissionSet"),
        hidden: true,
        meta: { title: "资源权限配置" }
      },
      {
        path: "/data-permissions/data-register",
        name: "dataRegister",
        component: () => import("@/views/standard/dataPermission/dataRegister/dataRegister"),
        hidden: true,
        meta: { title: "数据集注册" }
      },
      {
        path: "/data-permissions/data-set",
        name: "dataSet",
        component: () => import("@/views/standard/dataPermission/dataSet/dataSet"),
        hidden: true,
        meta: { title: "数据集配置" }
      },
      {
        path: "/data-permissions/data-permission-set",
        name: "dataPermissionSet",
        component: () => import("@/views/standard/dataPermission/dataPermissionSet/dataPermissionSet"),
        hidden: true,
        meta: { title: "数据权限配置" }
      },
      {
        path: "/data-permissions/params-manage",
        name: "ParamsManage",
        component: () => import("@/views/standard/dataPermission/paramsManage/paramsManage"),
        hidden: true,
        meta: { title: "参数管理" }
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Cockpit",
        component: () => import("@/views/standard/cockpit/index"),
        meta: { title: "首页", icon: "dashboard", affix: true }
      },
      {
        path: "/external",
        name: "External",
        component: () => import("@/views/standard/external"),
        meta: { title: "Ftfactory", icon: "dashboard" },
        hidden: true
      }]
  },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/cockpit',
  //   children: [
  //     {
  //       path: 'cockpit',
  //       name: 'Cockpit',
  //       component: () => import('@/views/standard/cockpit/index'),
  //       meta: { title: '驾驶舱', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  {
    path: "/superAdmin",
    component: Layout,
    redirect: "/superAdmin/org-group",
    meta: { title: "组织群" },
    hidden: true,
    children: [
      {
        path: "/superAdmin/org-group",
        name: "orgGroup",
        component: () => import("@/views/standard/superAdmin/orgGroup"),
        hidden: false,
        meta: { title: "组织群" }
      },
      {
        path: "/superAdmin/org-group/detail",
        name: "orgGroupDetail",
        component: () => import("@/views/standard/superAdmin/orgGroup/detail"),
        hidden: true,
        meta: {
          title: "组织群详情",
          breadcrumb: false,
          hiddenTag: true, //  在tags模式下是否显示
          tagReplace: "/superAdmin/org-group", //  替代显示tag的路由
          nocache: true
        }
      }
    ]
  },
  {
    path: "/404",
    component: () => import("@/views/standard/404"),
    hidden: true
  },
  /*
   * {
   *   path: "/layout",
   *   component: Layout,
   *   name: "TreeListLayout",
   *   children: [
   *     {
   *       path: "treeListLayout",
   *       name: "list",
   *       component: () => import("@/views/standard/layout/TreeListLayout"),
   *       meta: { title: "树形布局", icon: "el-icon-s-custom" },
   *     }
   *   ],
   * },
   */

  {
    path: "/business",
    component: Layout,
    name: "Business",
    redirect: "/business/business-list",
    hidden: "true",
    meta: { title: "组织管理" },
    children: [
      {
        path: "/org/create",
        name: "orgCreate",
        component: () => import("@/views/standard/business/components/create"),
        hidden: true,
        meta: {
          title: "创建组织",
          breadcrumb: false,
          hiddenTag: true, //  在tags模式下是否显示
          tagReplace: "/business/business-list", //  替代显示tag的路由
          nocache: true
        }
      },
      {
        path: "/org/detail",
        name: "orgDetail",
        component: () => import("@/views/standard/business/components/detail"),
        hidden: true,
        meta: {
          title: "组织详情",
          breadcrumb: false,
          hiddenTag: true, //  在tags模式下是否显示
          tagReplace: "/business/business-list", //  替代显示tag的路由
          nocache: true
        }
      }
    ]
  }

  /*
   * {
   *   path: "/business",
   *   component: Layout,
   *   name: "Business",
   *   redirect: "/business/list",
   *   meta: { title: "企业管理", icon: "el-icon-s-custom" },
   *   children: [
   *     {
   *       path: "list",
   *       name: "list",
   *       component: () => import("@/views/standard/business/index"),
   *       meta: { title: "企业管理", icon: "el-icon-s-custom", breadcrumb: false },
   *     },
   *     {
   *       path: "allot/:id",
   *       name: "allot",
   *       hidden: true,
   *       component: () => import("@/views/standard/business/components/allot"),
   *       meta: { title: "分配权限" },
   *     },
   *   ],
   * },
   * {
   *   path: "/operate",
   *   component: Layout,
   *   name: "OperatelogList",
   *   children: [
   *     {
   *       path: "loglist",
   *       name: "loglist",
   *       component: () => import("@/views/standard/operate/logslist"),
   *       meta: {
   *         title: "操作管理",
   *         icon: "el-icon-user-solid",
   *       },
   *     },
   *   ],
   * },
   * {
   *   path: "/role",
   *   component: Layout,
   *   children: [
   *     {
   *       path: "index",
   *       name: "Role",
   *       component: () => import("@/views/standard/role/index"),
   *       meta: { title: "角色管理", icon: "el-icon-user-solid" },
   *     },
   *   ],
   * },
   */

  /*
   * {
   *   path: "/user",
   *   component: Layout,
   *   redirect: "/user/index",
   *   name: "user",
   *   children: [
   *     {
   *       path: "index",
   *       name: "User",
   *       component: () => import("@/views/standard/user/user-list"),
   *       meta: {
   *         title: "用户管理",
   *         icon: "el-icon-user-solid",
   *       },
   *     },
   *   ],
   * },
   */
];

const createRouter = () => new Router({
  // mode: "history", // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
});

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
